// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var ExtensionNumberAvailability;
(function (ExtensionNumberAvailability) {
    ExtensionNumberAvailability["UNSPECIFIED"] = "UNSPECIFIED";
    ExtensionNumberAvailability["AVAILABLE"] = "AVAILABLE";
    ExtensionNumberAvailability["IN_USE"] = "IN_USE";
    ExtensionNumberAvailability["FORBIDDEN"] = "FORBIDDEN";
})(ExtensionNumberAvailability || (ExtensionNumberAvailability = {}));
export var ExtensionNumberAvailability_index;
(function (ExtensionNumberAvailability_index) {
    ExtensionNumberAvailability_index[ExtensionNumberAvailability_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ExtensionNumberAvailability_index[ExtensionNumberAvailability_index["AVAILABLE"] = 1] = "AVAILABLE";
    ExtensionNumberAvailability_index[ExtensionNumberAvailability_index["IN_USE"] = 2] = "IN_USE";
    ExtensionNumberAvailability_index[ExtensionNumberAvailability_index["FORBIDDEN"] = 3] = "FORBIDDEN";
})(ExtensionNumberAvailability_index || (ExtensionNumberAvailability_index = {}));
export var ValidationSeverity_Enum;
(function (ValidationSeverity_Enum) {
    ValidationSeverity_Enum["OK"] = "OK";
    ValidationSeverity_Enum["WARNING"] = "WARNING";
    ValidationSeverity_Enum["ERROR"] = "ERROR";
    ValidationSeverity_Enum["FATAL"] = "FATAL";
})(ValidationSeverity_Enum || (ValidationSeverity_Enum = {}));
export var ValidationSeverity_Enum_index;
(function (ValidationSeverity_Enum_index) {
    ValidationSeverity_Enum_index[ValidationSeverity_Enum_index["OK"] = 0] = "OK";
    ValidationSeverity_Enum_index[ValidationSeverity_Enum_index["WARNING"] = 1] = "WARNING";
    ValidationSeverity_Enum_index[ValidationSeverity_Enum_index["ERROR"] = 2] = "ERROR";
    ValidationSeverity_Enum_index[ValidationSeverity_Enum_index["FATAL"] = 3] = "FATAL";
})(ValidationSeverity_Enum_index || (ValidationSeverity_Enum_index = {}));
export var ValidateDestroyErrorCode_Enum;
(function (ValidateDestroyErrorCode_Enum) {
    ValidateDestroyErrorCode_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    ValidateDestroyErrorCode_Enum["MISSING_EXTENSION"] = "MISSING_EXTENSION";
    ValidateDestroyErrorCode_Enum["MISSING_SIP_PROFILE"] = "MISSING_SIP_PROFILE";
    ValidateDestroyErrorCode_Enum["MISSING_VOICEMAIL_BOX"] = "MISSING_VOICEMAIL_BOX";
    ValidateDestroyErrorCode_Enum["MISSING_DIRECT_INSTRUCTION_SET"] = "MISSING_DIRECT_INSTRUCTION_SET";
    ValidateDestroyErrorCode_Enum["DEVICE_IS_STILL_IN_USE"] = "DEVICE_IS_STILL_IN_USE";
    ValidateDestroyErrorCode_Enum["VOICEMAIL_BOX_HAS_NEW_MESSAGES"] = "VOICEMAIL_BOX_HAS_NEW_MESSAGES";
    ValidateDestroyErrorCode_Enum["VOICEMAIL_BOX_HAS_SAVED_MESSAGES"] = "VOICEMAIL_BOX_HAS_SAVED_MESSAGES";
    ValidateDestroyErrorCode_Enum["VOICEMAIL_BOX_IS_SHARED"] = "VOICEMAIL_BOX_IS_SHARED";
})(ValidateDestroyErrorCode_Enum || (ValidateDestroyErrorCode_Enum = {}));
export var ValidateDestroyErrorCode_Enum_index;
(function (ValidateDestroyErrorCode_Enum_index) {
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["MISSING_EXTENSION"] = 1] = "MISSING_EXTENSION";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["MISSING_SIP_PROFILE"] = 2] = "MISSING_SIP_PROFILE";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["MISSING_VOICEMAIL_BOX"] = 3] = "MISSING_VOICEMAIL_BOX";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["MISSING_DIRECT_INSTRUCTION_SET"] = 4] = "MISSING_DIRECT_INSTRUCTION_SET";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["DEVICE_IS_STILL_IN_USE"] = 6] = "DEVICE_IS_STILL_IN_USE";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["VOICEMAIL_BOX_HAS_NEW_MESSAGES"] = 7] = "VOICEMAIL_BOX_HAS_NEW_MESSAGES";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["VOICEMAIL_BOX_HAS_SAVED_MESSAGES"] = 8] = "VOICEMAIL_BOX_HAS_SAVED_MESSAGES";
    ValidateDestroyErrorCode_Enum_index[ValidateDestroyErrorCode_Enum_index["VOICEMAIL_BOX_IS_SHARED"] = 9] = "VOICEMAIL_BOX_IS_SHARED";
})(ValidateDestroyErrorCode_Enum_index || (ValidateDestroyErrorCode_Enum_index = {}));
export const LineAPI = {
    Generate(fn, req) {
        return fn(`/phone-devices/lines/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetLineNumberAvailability(fn, req) {
        try {
            fm.validateUrlParam(req["extensionNumber"], "extensionNumber");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-devices/lines/v1/extension-number/${req["extensionNumber"]}/availability?${fm.renderURLSearchParams(req, ["extensionNumber"])}`, { method: "GET" });
    },
    DestroyByDeviceID(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-devices/lines/v1/device-id/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    ValidateDestroyByDeviceId(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone-devices/lines/v1/device-id/${req["id"]}/validate-destroy`, { method: "POST" });
    },
};
